import { render, staticRenderFns } from "./Walls.vue?vue&type=template&id=d8577c2e&scoped=true"
import script from "./Walls.vue?vue&type=script&lang=js"
export * from "./Walls.vue?vue&type=script&lang=js"
import style0 from "./Walls.vue?vue&type=style&index=0&id=d8577c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8577c2e",
  null
  
)

export default component.exports